import { TaskType as GqlTaskType } from '@willow/graphql-iso/src/app/backend';
import { assertNever, TaskType } from '@willow/types-iso';

import { gqlToIsoTaskType } from './types';

export const getGqlTaskTitle = (type: GqlTaskType, title?: string) => getTaskTitle(gqlToIsoTaskType(type), title);

export const getTaskTitle = (type: TaskType, title?: string) => {
  if (title != null) return title;

  switch (type) {
    case 'custom':
      return 'Custom';
    case 'loanFlaggedTooLong':
      return 'Loan Flagged 5+ days';
    case 'forwardMiscollectedFunds':
      return 'Forward Overcollected Funds';
    case 'pastGrace':
      return 'Past Grace Period';
    case 'applyDefaultInterest':
      return 'Apply Default Interest';
    case 'disburseEscrowFunds':
      return 'Disburse Escrow Funds';
    case 'disburseEscrowFundsToBorrower':
      return 'Disburse Escrow Funds to borrower';
    case 'generateManualStatement':
      return 'Generate Statement';
    case 'welcomeCall':
      return 'Welcome Call';
    case 'poolPendingActivation':
      return 'Enter Pool Details';

    // Payoff Tasks
    case 'generateRequestedPayoff':
      return 'Payoff Statement Requested';
    case 'generatePayoffStatement':
      return 'Generate Payoff Statement';
    case 'payoffReimbursement':
      return 'Payoff Reimbursement Due';
    case 'pendingPaymentAtPayoffReimbursement':
      return 'Reimburse Payment (Post-Payoff)';
    // Lien Release Tasks
    case 'partialLienRelease':
      return 'Partial Lien Release';
    case 'fullLienRelease':
      return 'Lien Release';
    // Mail Tasks
    case 'mailBundle':
      return 'Mail Documents';
    case 'mailPreActiveWelcomeLetter':
      return 'Mail Welcome Letter';
    case 'mailGoodbyeLetter':
      return 'Mail Goodbye Letter';
    case 'mailMonthlyStatement':
      return 'Mail Statement';
    case 'mailMortgageeLetter':
      return 'Mail Mortgagee Letter';
    case 'mail1098Form':
      return 'Mail 1098 Form';
    case 'mailEscrowAnalysis':
      return 'Mail Escrow Analysis';

    // foreclosure steps
    case 'foreclosureStepDemandLetters':
      return 'Foreclosure Demand Letters';
    case 'foreclosureStepDemandLetterExpires':
      return 'Foreclosure Demand Letter Expires';
    case 'foreclosureStepReferClosureAttorney':
      return 'Foreclosure Refer Attorney';
    case 'foreclosureStepJudicialState':
      return 'Foreclosure Judicial State';
    case 'foreclosureStepNonJudicialState':
      return 'Foreclosure Non-Judicial State';
    case 'foreclosureStepHomeSale':
      return 'Foreclosure Home Sale';

    // reo steps
    case 'reoStepEvictionOfOccupiedProperty':
      return 'REO Eviction of Occupied Property';
    case 'reoStepOrderInspectionAndValuation':
      return 'REO Order Inspection and Valuation';
    case 'reoStepRepairsAndPreservation':
      return 'REO Repairs and Preservation';
    case 'reoStepPropertyListing':
      return 'REO Property Listing';
    case 'reoStepPropertyReduction':
      return 'REO Property Reduction';
    case 'reoStepOfferEvaluations':
      return 'REO Offer Evaluations';
    case 'reoStepCounterOfferDetails':
      return 'REO Counter Offer Details';
    case 'reoStepContractStatus':
      return 'REO Contract Status';

    // chapter7 steps
    case 'chapter7StepAttorneyRelief':
      return 'Chapter 7 Attorney Referral & Motion for Relief';
    case 'chapter7StepCreditorMeeting':
      return 'Chapter 7 Creditor Meeting';
    case 'chapter7StepFilingStay':
      return 'Chapter 7 Filing Type & Apply Automatic Stay';
    case 'chapter7StepHearingDate':
      return 'Chapter 7 Hearing Date';
    case 'chapter7StepHearingOutcome':
      return 'Chapter 7 Hearing Outcome';

    // chapter 13 steps
    case 'chapter13StepFilingStay':
      return 'Chapter 13 Filing Stay';
    case 'chapter13StepAttorneyReferral':
      return 'Chapter 13 Attorney Referral';
    case 'chapter13StepCreditorMeeting':
      return 'Chapter 13 Creditor Meeting';
    case 'chapter13StepPlanInPlace':
      return 'Chapter 13 Plan in Place';
    case 'chapter13StepPlanMonitoring':
      return 'Chapter 13 Plan Monitoring';

    // delinquency steps
    case 'delinquencyStepPastGrace':
      return 'Delinquency Past Grace Period';
    case 'delinquencyStepMortgageAssistanceRequest':
      return 'Delinquency Mortgage Assistance Request';
    case 'delinquencyStepBorrowerResponsePackage':
      return 'Delinquency Borrower Response Package';
    case 'delinquencyStepFlexModificationEligibility':
      return 'Delinquency Flex Modification Eligibility';
    case 'delinquencyStepFlexModificationTerms':
      return 'Delinquency Flex Modification Terms';
    case 'delinquencyStepSendBreachTerms':
      return 'Delinquency Send Breach Terms';
    case 'delinquencyStepPreForeclosureReferral':
      return 'Delinquency Pre-Foreclosure Referral';

    // Portal Requests
    case 'generalInquiry':
      return 'Borrower Inquiry';
    case 'drawRequest':
      return 'Draw Request';
    case 'escrowWaiverRequest':
      return 'Escrow Waiver Request';
    case 'paymentAssistanceInquiry':
      return 'Payment Assistance Inquiry';
    case 'pmiCancellationRequest':
      return 'PMI Cancellation Request';
    case 'verificationOfMortgageRequest':
      return 'Verification of Mortgage Request';

    // Failed Payments
    case 'disableUsioAccount':
    case 'disableRepayAccount':
      return 'Bank Account Locked';
    case 'achPaymentFailed':
      return 'ACH Payment Failed';
    case 'workflowV2':
      return 'Workflow Tasks';
    default:
      assertNever(type);
  }
};
